import React, { useState } from "react";
import { Button } from "../../../../../../stories/Button/Button";
import CheckAll from "../../../../../../images/MoreInfo.svg";
import Filter from "../../../../../../images/Filter.svg";
import DownArrow from "../../../../../../images/DownArrow.svg";
import useAssetTableJson from "../../../../../../json/useAssetTableJson";
import {
  Checkbox,
  TableContainer,
  TableHead,
  Table,
  TableRow,
  TableCell,
  TableBody,
  TextField,
} from "@mui/material";
import { Label } from "@mui/icons-material";
import { TableHeaderProps } from "../../../../../../utils/types";
import Input from "../../../../../../stories/Input/Input";
import {
  FormAutocomplete,
  formClasses,
} from "../../../../../../styles/AutocompleteStyles";
import { Keys } from "../../../../../../utils/Enum.keys";
import {
  CustomModal,
  handleMUISelectEvent,
} from "../../../../../../utils/UtilFunctions";
import ViewConfiguration from "../ViewConfiguration";
import { ViewConfigurationStyles } from "../../../../../../styles/CustomModalStyles";

export const enum StockEntryTable {
  Start_Date = "start_date",
  End_Date = "end_date",
  AMC_Start_Date = "amc_start_date",
  AMC_End_Date = "amc_end_date",
  INC_Start_Date = "inc_start_date",
  INC_end_Date = "inc_end_date",
  Maintained_By = "maintained_by",
  SL_No = "id",
  Serial_No = "serial_no",
  Batch = "batch",
  Expiry = "expiry",
  Warranty = "warranty",
  AMC_Enabled = "amc_enabled",
  AMC = "amc",
  Geo_Location = "geo_location",
  Insurance = "insurance",
  Stock_Location = "stock_location",
  Status = "ticketStatus"
}

const TableEdit = () => {
  const [viewConfig, setViewConfig] = useState(false);
  const [filterColumns, setFilterColumns] = useState(false);
  const { Purchase } = useAssetTableJson();

  const [columns, setColumns] = useState(Purchase.StockEntry.Add.SubHeader);
  const visibleColumns = columns.filter((col) => !col.hideable);

  const handleColumnToggle = (field: string) => {
    setColumns((prevColumns) =>
      prevColumns.map((col) => {
        if (
          field === StockEntryTable.Warranty &&
          ((col.field as unknown as StockEntryTable) ===
            StockEntryTable.Start_Date ||
            (col.field as unknown as StockEntryTable) ===
              StockEntryTable.End_Date)
        ) {
          return { ...col, hideable: !col.hideable };
        } else if (
          field === StockEntryTable.Insurance &&
          ((col.field as unknown as StockEntryTable) ===
            StockEntryTable.INC_Start_Date ||
            (col.field as unknown as StockEntryTable) ===
              StockEntryTable.INC_end_Date)
        ) {
          return { ...col, hideable: !col.hideable };
        } else if (
          field === StockEntryTable.AMC &&
          ((col.field as unknown as StockEntryTable) ===
            StockEntryTable.AMC_Start_Date ||
            (col.field as unknown as StockEntryTable) ===
              StockEntryTable.AMC_End_Date)
        ) {
          return { ...col, hideable: !col.hideable };
        }

        return col.field === field ? { ...col, hideable: !col.hideable } : col;
      })
    );
  };

  return (
    <div className="add-stock-entry__block">
      <div className="row g-0">
        <div className="col flex-end">
          <Button onClick={() => setViewConfig(!viewConfig)}>
            <img src={CheckAll} alt="" />
            Check All configurations
          </Button>
          <label
            className="add-stock-entry__block--filter"
            onClick={() => setFilterColumns(!filterColumns)}
          >
            <img src={Filter} alt="" /> Filter Column
            <img src={DownArrow} alt="" />
          </label>
          {filterColumns && (
            <div className="add-stock-entry__block--filter-checkboxes">
              {columns
                .filter(
                  (th) =>
                    ![
                      StockEntryTable.Start_Date,
                      StockEntryTable.End_Date,
                      StockEntryTable.AMC_Start_Date,
                      StockEntryTable.AMC_End_Date,
                      StockEntryTable.INC_Start_Date,
                      StockEntryTable.INC_end_Date,
                    ].includes(th.field as unknown as StockEntryTable)
                )
                .map((col) => (
                  <div key={col.field}>
                    <Checkbox
                      checked={col.hideable ? false : true}
                      onChange={() => {
                        handleColumnToggle(col.field);
                      }}
                    />
                    <Label>{col.headerName}</Label>
                  </div>
                ))}
              <Button
                mode="cancel"
                onClick={() => setFilterColumns(!filterColumns)}
              />
            </div>
          )}
        </div>
      </div>
      <div className="add-stock-entry__block--table-container">
        <TableContainer className="add-stock-entry__block--table">
          <Table stickyHeader>
            <TableHead>
              <TableRow>
                {visibleColumns
                  .filter((th) =>
                    [
                      StockEntryTable.SL_No,
                      StockEntryTable.Serial_No,
                      StockEntryTable.Batch,
                      StockEntryTable.Expiry,
                      StockEntryTable.Maintained_By,
                      StockEntryTable.AMC_Enabled,
                      StockEntryTable.Geo_Location,
                      StockEntryTable.Stock_Location,
                      StockEntryTable.Warranty,
                      StockEntryTable.AMC,
                      StockEntryTable.Insurance,
                    ].includes(th.field as unknown as StockEntryTable)
                  )
                  .map((th: TableHeaderProps, index: React.Key) => {
                    return (
                      <TableCell
                        key={index}
                        rowSpan={
                          [
                            StockEntryTable.SL_No,
                            StockEntryTable.Serial_No,
                            StockEntryTable.Batch,
                            StockEntryTable.Expiry,
                            StockEntryTable.Maintained_By,
                            StockEntryTable.AMC_Enabled,
                            StockEntryTable.Geo_Location,

                            StockEntryTable.Stock_Location,
                          ].includes(th.field as unknown as StockEntryTable)
                            ? 2
                            : 1
                        }
                        colSpan={
                          [
                            StockEntryTable.Warranty,
                            StockEntryTable.AMC,
                            StockEntryTable.Insurance,
                          ].includes(th.field as unknown as StockEntryTable)
                            ? 2
                            : 1
                        }
                      >
                        {th.headerName}
                      </TableCell>
                    );
                  })}
              </TableRow>
              <TableRow>
                {visibleColumns
                  .filter((th) =>
                    [
                      StockEntryTable.Start_Date,
                      StockEntryTable.End_Date,
                      StockEntryTable.AMC_Start_Date,
                      StockEntryTable.AMC_End_Date,
                      StockEntryTable.INC_Start_Date,
                      StockEntryTable.INC_end_Date,
                    ].includes(th.field as unknown as StockEntryTable)
                  )
                  .map((th: TableHeaderProps, index: React.Key) => {
                    return <TableCell key={index}>{th.headerName}</TableCell>;
                  })}
              </TableRow>
            </TableHead>
            <TableBody>
              <TableRow>
                {visibleColumns.map((th: TableHeaderProps, index) => {
                  if (th.field === StockEntryTable.SL_No) {
                    return (
                      <TableCell id="td-center" key={index}>
                        {index + 1}
                      </TableCell>
                    );
                  } else if (th.field === StockEntryTable.Serial_No) {
                    return (
                      <TableCell key={index}>
                        <Input />
                      </TableCell>
                    );
                  } else if (th.field === StockEntryTable.Batch) {
                    return (
                      <TableCell key={index}>
                        <Input />
                      </TableCell>
                    );
                  } else if (th.field === StockEntryTable.Expiry) {
                    return (
                      <TableCell key={index}>
                        <Input type="date" />
                      </TableCell>
                    );
                  } else if (th.field === StockEntryTable.Start_Date) {
                    return (
                      <TableCell key={index}>
                        <Input type="date" />
                      </TableCell>
                    );
                  } else if (th.field === StockEntryTable.End_Date) {
                    return (
                      <TableCell key={index}>
                        <Input type="date" />
                      </TableCell>
                    );
                  } else if (th.field === StockEntryTable.Maintained_By) {
                    return (
                      <TableCell key={index}>
                        <Input />
                      </TableCell>
                    );
                  } else if (th.field === StockEntryTable.AMC_Enabled) {
                    return (
                      <TableCell key={index}>
                        <Input />
                      </TableCell>
                    );
                  } else if (th.field === StockEntryTable.AMC_Start_Date) {
                    return (
                      <TableCell key={index}>
                        <Input type="date" />
                      </TableCell>
                    );
                  } else if (th.field === StockEntryTable.AMC_End_Date) {
                    return (
                      <TableCell key={index}>
                        <Input type="date" />
                      </TableCell>
                    );
                  } else if (th.field === StockEntryTable.Geo_Location) {
                    return (
                      <TableCell key={index}>
                        <Input />
                      </TableCell>
                    );
                  } else if (th.field === StockEntryTable.INC_Start_Date) {
                    return (
                      <TableCell key={index}>
                        <Input />
                      </TableCell>
                    );
                  } else if (th.field === StockEntryTable.INC_end_Date) {
                    return (
                      <TableCell key={index}>
                        <Input />
                      </TableCell>
                    );
                  } else if (th.field === StockEntryTable.Stock_Location) {
                    return (
                      <TableCell key={index}>
                        <FormAutocomplete
                          className={formClasses.inputRoot}
                          options={["a", "b"]}
                          onKeyDown={(e) => {
                            if (e.key === Keys.ENTER) {
                              e.preventDefault();
                              handleMUISelectEvent(e);
                            }
                          }}
                          // value={selectedStockOrService}
                          // onChange={(e, newValue) => {
                          //   if (newValue) {
                          //     setFormData({
                          //       ...formData,
                          //       isStockOrService: newValue as string,
                          //     });
                          //   } else {
                          //     setFormData({
                          //       ...formData,
                          //       isStockOrService: "",
                          //     });
                          //   }
                          // }}
                          openOnFocus
                          forcePopupIcon
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              fullWidth
                              className={formClasses.formControlRoot}
                            />
                          )}
                        />
                      </TableCell>
                    );
                  } else return null;
                })}
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
      </div>
      <CustomModal
        isOpen={viewConfig}
        onRequestClose={() => setViewConfig(!viewConfig)}
        contentComponent={<ViewConfiguration setModalFlag={setViewConfig} />}
        style={ViewConfigurationStyles}
      />
    </div>
  );
};

export default TableEdit;
